import React from 'react'
import './preloader.scss'

const Preloader = () => {
    return (
        <div className="order__step_shipping_preloader">
            <div className="loader components-roller1">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Preloader
